import { api } from '@api'
import {
  ContractsSupplier,
  ContractSupplierFilters,
  ContractsSupplierAsnumsResponse,
  ContractsSupplierFilterResponse,
} from '@types'

const base = '/sap-item-supplier'

interface GetContractsSupplierResponse {
  contracts: ContractsSupplier
}

type Params = {
  filters?: ContractSupplierFilters
}

const getContractsSupplier = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetContractsSupplierResponse>(base, {
    params: {
      ...filters,
    },
  })

  return response.data.contracts
}

const getContractsSupplierFilter = async (params: Params) => {
  const { filters } = params
  const response = await api.get<ContractsSupplierFilterResponse>(base + '/filters', {
    params: filters,
  })

  return response.data
}

const getSupplierAsnums = async (params: Params) => {
  const { filters } = params
  const response = await api.get<ContractsSupplierAsnumsResponse>(base + '/asnums', {
    params: filters,
  })

  return response.data
}

export const ContractsSupplierApi = {
  getContractsSupplier,
  getContractsSupplierFilter,
  getSupplierAsnums,
}
